/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Updaterequiredtitle2Inputs */



/**
* | output |
* | --- |
* | "Let's update the app" |
*
* @param {Updaterequiredtitle2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const updaterequiredtitle2 = /** @type {((inputs?: Updaterequiredtitle2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Updaterequiredtitle2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Let's update the app")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vamos a actualizar la app")
	return /** @type {LocalizedString} */ ("Давай обновим приложение")
});
export { updaterequiredtitle2 as "updateRequiredTitle" }